export const HELPCENTER_LINK_EXTERNAL = 'https://help.trueqrcode.com/en/';
